<script>
export default {
  props: {
    component: Object,
    handler: Object,
    selectedCandidate: Object,
  },
  data() {
    return {
      modalInput: this.component.candidate_name + ' (Attendee)',
      modalShow: false,
      pending: false,
      modalNoProjectShow: false,
    };
  },
  methods: {
    sendInvitation: async function () {
      if (!this.component.vcreator18) {
        this.modalNoProjectShow = true;
      } else {
        this.modalShow = true;
      }
    },
    addSourceAndSendLink: async function () {
      this.pending = true;
      try {
        await this.handler.action(this.component, "add_source_and_send_link", [
          this.modalInput,
        ]);
      } catch (e) {
        return;
      } finally {
        this.pending = false;
      }
      this.modalShow = false;
    },
  },
};
</script>

<template>
  <div class="stepin-invitation">
    <div class="stepin-invitation-modal">
      <f-modal-base
        closable
        v-if="modalNoProjectShow"
        @close="modalNoProjectShow = false"
        :pending="pending"
      >
        <template #title2>No Studio project selected</template>
        <template #content>
          <f-hint type="notice"
            ><template #message>
              You need to select a Studio project first!</template
            >
          </f-hint>
        </template>
        <template #actions>
          <f-button @click="modalNoProjectShow = false">Ok</f-button>
        </template>
      </f-modal-base>
    </div>
    <div class="stepin-invitation-modal">
      <f-modal-base
        closable
        v-if="modalShow"
        @close="modalShow = false"
        :pending="pending"
      >
        <template #title2>Send invitation</template>
        <template #content>
          <f-hint
            ><template #message>
              A new "Remote Speaker" source will be added to the "{{
                component.project_title
              }}" project. The link to access the room will then be sent to the
              participant</template
            >
          </f-hint>
          <f-textfield :input.sync="modalInput">
            <template #label>Source name</template>
          </f-textfield>
        </template>
        <template #actions>
          <f-button type="tertiary" @click="modalShow = false">Cancel</f-button>
          <f-button type="primary" @click="addSourceAndSendLink()"
            >Add source and send link</f-button
          >
        </template>
      </f-modal-base>
    </div>
    <f-button type="primary" :pending="pending" @click="sendInvitation()"
      ><f-icon icon="fa6-message"></f-icon>Send invitation</f-button
    >
  </div>
</template>

<style lang="scss" >
.stepin-invitation-modal {
  .f-dialog {
    width: 500px;

    .f-dialog-content {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
  }
}
</style>